module.exports = __webpack_public_path__ + "static/img/MG_1.56a241f1.png";